import { Col, Progress, Row, Typography } from 'antd'
import Loading from './Loading'
const { Text, Title } = Typography
type ProgressSectionModel = {
  title: string
  total: number
  active: number
  activeTitle: string
  inactive: number
  inactiveTitle: string
  loading?: boolean
}
export function ProgressSection(props: ProgressSectionModel) {
  return (
    <>
      <Col xs={24} lg={24} className='py-2 px-2'>
        <div className='p-2 py-4 rounded bg-white h-100 '>
          <div className='px-3 bg-white '>
            <Row justify='space-between'>
              <Col>
                <h6 className='text-general '>{props.title}</h6>
              </Col>
              <Col>
                <Title level={3} className='total-data'>
                  {props.total}
                </Title>
              </Col>
            </Row>
          </div>
          <div className='p-3'>
            {props.loading ? (
              <Loading />
            ) : (
              <>
                <Row justify='space-between'>
                  <Text strong className='title-active-color '>
                    {props.activeTitle}
                  </Text>
                  <Text strong>{props.active}</Text>
                </Row>
                <Progress
                  percent={(props.active / props.total) * 100}
                  showInfo={false}
                  strokeWidth={5}
                  strokeColor='#7549AD '
                />

                <Row justify='space-between'>
                  <Text className='title-inactive-color' strong>
                    {props.inactiveTitle}
                  </Text>
                  <Text strong>{props.inactive}</Text>
                </Row>
                <Progress
                  percent={(props.inactive / props.total) * 100}
                  showInfo={false}
                  strokeWidth={5}
                  strokeColor='#7549AD'
                />
              </>
            )}
          </div>
        </div>
      </Col>
    </>
  )
}
